import { Campaign } from '@features/campaigns/subdomains/visitation/api';
import { RslReport } from '../../../api/schema';
import { Upsell } from '../Upsell';
import { Stack, Typography } from '@mui/material';
import { ChartCards } from './ChartCards';
import { AdSpendCard } from './AdSpendCard';
import { AIInsights } from './AIInsights';

type SummaryProps = {
  report: RslReport;
  reports: RslReport[];
  campaign: Pick<
    Campaign,
    'id' | 'name' | 'salesRequested' | 'startDate' | 'endDate'
  >;
};

export const Summary = (props: SummaryProps) => {
  if (!props.report.hasVisitMetrics) {
    return (
      <Upsell
        context="visit"
        campaignId={props.campaign.id}
        requested={props.campaign.salesRequested}
      />
    );
  }

  return (
    <>
      <Typography variant="h6" sx={{ mb: '1rem' }}>
        Visit Summary
      </Typography>
      <Stack direction="column" gap="1rem">
        <AdSpendCard
          reportDate={props.report.reportDate}
          totalVisits={props.report.totalProjectedVisits}
          incrementalVisits={props.report.projectedIncrementalVisits}
          campaign={props.campaign}
        />
        <AIInsights report={props.report} campaignName={props.campaign.name} />
        <ChartCards selectedReport={props.report} reports={props.reports} />
      </Stack>
    </>
  );
};
